export const environment = {
  production: false,
  apiUrl: "https://ciwc-api.project-domain.com/api",
};